import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="profile-photo-preview"
export default class extends Controller {
  static targets = ["input", "preview", "initials"]

  connect() {
    console.log("Profile photo preview controller connected")
  }

  preview(event) {
    const file = event.target.files[0]
    
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader()
      
      reader.onload = (e) => {
        // Hide initials and show image preview
        if (this.hasInitialsTarget) {
          this.initialsTarget.style.display = 'none'
        }
        
        // Update the preview image
        this.previewTarget.src = e.target.result
        this.previewTarget.style.display = 'block'
        this.previewTarget.classList.add('w-full', 'h-full', 'object-cover')
      }
      
      reader.readAsDataURL(file)
    } else if (file) {
      // Invalid file type
      alert('Please select a valid image file (JPG, PNG, GIF, WebP)')
      event.target.value = ''
    }
  }

  // Reset preview if file input is cleared
  reset() {
    if (this.hasPreviewTarget) {
      this.previewTarget.style.display = 'none'
    }
    
    if (this.hasInitialsTarget) {
      this.initialsTarget.style.display = 'block'
    }
  }
}